<template>
  <div>
    <navbar-sidebar :menuType="menuType" />
    <v-app-bar fixed clipped-right app hide-on-scroll :elevation="2" dark>
      <v-img
        alt="DT One logo"
        :src="require('@/assets/Logo-DarkBg.png')"
        contain
        transition="scale-transition"
        height="38px"
        max-width="150px"
        class="mr-2"
      />
      <v-toolbar-title>
        <span class="primary--text title text-capitalize">
        {{menuType }}
        </span>
      </v-toolbar-title>
      <v-spacer />

      <v-toolbar-items>
        <v-menu bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn text icon color="primary" v-on="on">
              <v-icon>apps</v-icon>
            </v-btn>
          </template>
          <navbar-tile class="blue-grey darken-4"
            :containerStyle="navBarTileContainerStyle"
            :tileWidth="navBarTileWidth"
            :iconSize="navBarIconSize"
          />
        </v-menu>
        <v-btn icon @click="handleFullScreen()">
          <v-icon color="primary">fullscreen</v-icon>
        </v-btn>
      </v-toolbar-items>

      <v-app-bar-nav-icon
        @click.stop="toggleSidebar"
        color="primary"
      ></v-app-bar-nav-icon>
    </v-app-bar>
  </div>
</template>

<script>
import Util from '@/util';

export default {
  props: {
    menuType: String,
  },
  data() {
    return {
      navBarTileContainerStyle: {
        backgroundColor: '#fafafa',
        maxWidth: '500px',
      },
      navBarTileWidth: '64px',
      navBarIconSize: 'medium',
    };
  },
  methods: {
    toggleSidebar() {
      this.$store.commit('app/TOGGLE_SIDEBAR_MINI');
    },
    handleFullScreen() {
      Util.toggleFullScreen();
    },
  },
};
</script>

<style></style>
